// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201220/js/" + chunkId + "." + {"44":"0e017f80","225":"668417ba","481":"6846a18f","486":"b98c0eb9","770":"6eaf2bf6"}[chunkId] + ".0.30078401723167025.chunk.js";
};